export default {
    resource: 'registrations',
    successMessage: 'Your registration was successful.<br><br>Please check your email inbox for your registration confirmation and entry barcode.',
    newEntryButtonText: 'Add Another Attendee',
    submitButtonText: 'Submit'
};